import Instance from './Instance';

export default Instance;